import React, { useEffect, useState } from 'react';

export default function ProductLogo({ src, title }) {
    const [failed, setFailed] = useState(false);
    useEffect(() => setFailed(false), [src]);
    return (
        <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-gray-50 border border-gray-100 overflow-hidden text-lg font-semibold text-blue-700">
            {src && !failed
                ? <img src={src} alt="" referrerPolicy="no-referrer" className="h-full w-full object-contain p-1.5" onError={() => setFailed(true)} />
                : (title || '?').slice(0, 1).toUpperCase()}
        </span>
    );
}
